var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contextmenu',{attrs:{"disabled":!_vm.category,"buttons":_vm.buttons}},[_c('div',[_c('img',{attrs:{"src":require("@/assets/images/icons/navigation/trash.svg"),"alt":""}})]),_c('p',{class:_vm.$style.text},[_vm._v(" Очистить историю ")])])}
var staticRenderFns = []

export { render, staticRenderFns }